/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	export class Unit {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public static tileToLatLng(tileX:number, tileY:number, zoomLevel:number):LatLng {
			const n:number = Math.pow(2, zoomLevel);
			const lng:number = (tileX / n) * 360 - 180;
			const latRad:number = Math.atan(Math.sinh(Math.PI * (1 - 2 * (tileY / n))));
			const lat:number = latRad * (180 / Math.PI);
			return new LatLng(lat, lng);
		}

		public static meterToPixel(meter:number, zoomLevel:number):number {
			return meter * this.getPixelPerMeter(zoomLevel);
		}

		public static pixelToSpace(pixel:THREE.Vector2, y:number):THREE.Vector3 {
			return new THREE.Vector3(pixel.x, y,  pixel.y);
		}

		public static pixelElevationToSpace(pixel:THREE.Vector2, elevation:number, zoomLevel:number):THREE.Vector3 {
			return Unit.pixelToSpace(pixel, Unit.meterToPixel(elevation + Config.terrainElevationOffset, zoomLevel) * Config.terrainElevationMaxScale);
		}

		public static getPixelPerMeter(zoomLevel:number):number {
			let value:number = this.pixelPerMetersByZoomLevel[zoomLevel];
			if (value == null) value = this.pixelPerMetersByZoomLevel[zoomLevel] = this.getPixelMapSize(zoomLevel) / this.equatorLength;
			return value;
		}

		public static getPixelMapSize(zoomLevel:number):number {
			let value:number = this.pixelMapSizesByZoomLevel[zoomLevel];
			if (value == null) value = this.pixelMapSizesByZoomLevel[zoomLevel] = 256 * Math.pow(2, zoomLevel);
			return value;
		}





		public static toMs(dates:number = 0, hours:number = 0, minutes:number = 0, seconds:number = 0, milliseconds:number = 0):number {
			return dates * 86400000 + hours * 3600000 + minutes * 600000 + seconds * 1000 * milliseconds;
		}

		public static datesToMs(dates:number):number {
			return dates * 86400000;
		}

		public static hoursToMs(hours:number):number {
			return hours * 3600000;
		}

		public static minutesToMs(minutes:number):number {
			return minutes * 60000;
		}

		public static secondsToMs(seconds:number):number {
			return seconds * 1000;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		// ズームレベル毎のピクセル地図のサイズ(px)
		private static pixelMapSizesByZoomLevel:number[] = [];

		// ズームレベル毎の1mあたりのピクセル数(px)
		private static pixelPerMetersByZoomLevel:number[] = [];

		// 地球の赤道の長さ(m)
		private static equatorLength:number = 40075016.6855784861531768177614;
	}
}
